import clsx from 'clsx'
import {FC} from 'react'
import EnableAutoDiscount from '../../edit/EnableAutoDiscount'
import {useSelector} from 'react-redux'
import {RootState} from 'setup'
import {selectIsAutoDiscountRemoved} from 'app/features/orders/redux/order/orderEditSlice'

type Props = {
  title: Record<string, string>
  onClick: () => void
  isCursorDefault?: boolean
}

const WineClubDiscountButton: FC<Props> = ({title, onClick, isCursorDefault}) => {
  const isAutoDiscountRemoved = useSelector<RootState, boolean>(selectIsAutoDiscountRemoved)
  return (
    <div className='d-flex align-items-center gap-12'>
      <EnableAutoDiscount />
      <button
        id='btnAddDiscount'
        className={clsx(
          'p-0 py-2',
          isCursorDefault && 'cursor-default',
          isAutoDiscountRemoved
            ? 'border-0 bg-white text-dark fw-bold'
            : 'btn btn-link fw-bolder text-primary-active'
        )}
        data-bs-toggle='tooltip'
        data-bs-trigger='hover'
        title={title.name}
        data-bs-original-title='Coming soon'
        onClick={onClick}
        disabled={isAutoDiscountRemoved}
      >
        {title.name}
      </button>
    </div>
  )
}
export default WineClubDiscountButton
